module.exports = __webpack_public_path__ + "img/snipers_3.4a27532.jpg";